import API from '../../../../../services/api';

export const API_VEHICULOS = {
    getVehiculos: async (page, search) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/dashboard/vehiculos' + pagination + searcher).then(res => res.data);
    },
    getVehiculo: async (bastidor) => {
        return await API.get('/dashboard/vehiculos/' + bastidor).then(res => res.data);
    },
    getFechasAlmacenamiento: async (bastidor) => {
        return await API.get('/dashboard/fechas-almacenamiento/' + bastidor).then(res => res.data);
    }
}